import React from 'react';
import About from './Components/About';
import Contacts from './Components/Contacts';
import Photo from "./Components/Photo";
import './css/index.css'

function App() {

  const [page, setPage] = React.useState('photo')
  const [menu, setMenu] = React.useState(false)
  const isMobile = window.innerWidth <= 478 ? true : false

  const _setPage = (e) => {
    setPage(e)
    setMenu(false)
  }

  const [relevate, setRelevate] = React.useState(false)

  const setRl = (val) => {
    setRelevate(val)
    console.log('relevate ===>', relevate)
  }


  return (
    <div className={'container'}>
      <div className={!relevate ? 'wrapper relevate' : 'wrapper'}>

       {page === 'photo' && <div className="block__photo">
           <Photo fn={setRl} />

        </div>}
        {page === 'about' && <div className="block__about">
          <About  fn={setPage}/>
          </div>}
        {page === 'contacts' && <div className="block__contacts">
          <Contacts />
          </div>}
          {isMobile && menu && (
          <div className="mobile_menu">
          <div className="menu__list">
                <div onClick={() => _setPage('photo') }>Дизайн</div>
                <div>/</div>
                <div onClick={() => _setPage('about')}>О нас</div>
                <div>/</div>
                <div onClick={() => _setPage('contacts')}>Контакты</div>
              </div>
          </div>
          )}
              
            
        <div className="menu">
          <div className="menu__logo">buro*PT</div>
          
            {!isMobile && menu && (
              <div className="menu__list">
                <div onClick={() => setPage('photo')}>Дизайн</div>
                <div>/</div>
                <div onClick={() => setPage('about')}>О нас</div>
                <div>/</div>
                <div onClick={() => setPage('contacts')}>Контакты</div>
              </div>
            )}
            
          <div className={menu ? `utils mobileNavOpen` : 'utils'}>
          <div id="menuDivBurger">
        	<div className="inner">
                <div id="nav-icons" onClick={() => setMenu(!menu ? true : false)}>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
		</div>

          </div>
        </div>
      </div>
     
    </div>
  );
}

export default App;
